<template>
  <div v-if="tags.length" class="article-selected-tags-info">
    <span v-for="tag in tags" :key="tag.id" class="tag-item">
      {{ tag.name }}<sup class="tag-count">{{ tag.news_count }}</sup>
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { ArticleTagWithNewsCount } from '~/models/articles'

defineProps<{
  tags: ArticleTagWithNewsCount[]
}>()
</script>

<style lang="scss" scoped>
.article-selected-tags-info {
  display: flex;
  align-items: baseline;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 32px;

  @include vp-767 {
    gap: 12px;
    margin-bottom: 24px;
  }

  > .tag-item {
    font-weight: 400;
    font-size: 20px;
    line-height: 1.2;
    color: $color-default-black;

    @include vp-767 {
      font-size: 16px;
    }

    > .tag-count {
      color: $color-kiwi-50;
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      vertical-align: super;

      @include vp-767 {
        font-size: 12px;
      }
    }
  }
}
</style>
